
import { useSelector } from 'react-redux';

import { SearchAshevillePlay, SearchRsi, SearchTravcoding } from '@components';
import { TRAVCODING_HOME_TEMPLATE } from '@share/common-types';
import { RootState } from '@share/utils';

import './style.scss';

interface IProps {
  isVacationRentals?: boolean;
}

export function SearchPage(props: IProps) {
  const { isVacationRentals } = props;
  
  const loginStore = useSelector((state: RootState) => state.loginStore);
  
  const { account } = loginStore;
  
  const homePageTemplate = account?.homePageTemplate;
  const isRSITemplate = account?.isRSITemplate;
  const isAshevillePlay = account?.isAshevillePlay;

  const isTravcodingTemplate = !homePageTemplate || homePageTemplate === TRAVCODING_HOME_TEMPLATE;

  return (
    <div className="search-page">
      {!isAshevillePlay && isTravcodingTemplate && (
        <SearchTravcoding isVacationRentals={isVacationRentals || false} />)}

      {!isAshevillePlay && !isTravcodingTemplate && isRSITemplate && (
        <SearchRsi isVacationRentals={isVacationRentals} />)}

      {isAshevillePlay && (
        <SearchAshevillePlay />)}
    </div>
  );
}
